import firebase from "firebase/compat/app";
import "firebase/compat/functions";

const getFunctions = () => firebase.app().functions("us-central1");

export const CHAMPION_VIDEO_SLOTS = [
  { videoId: "ceo", label: "CEO" },
  { videoId: "board", label: "Board" },
  { videoId: "cmo", label: "CMO" },
  { videoId: "cno", label: "CNO" },
  { videoId: "cfo", label: "CFO" },
  { videoId: "compliance", label: "Compliance" },
];

export async function updateInstitutionLogo({ institutionId, logoUrl }) {
  const callable = getFunctions().httpsCallable("updateInstitutionLogo");
  const result = await callable({ institutionId, logoUrl });
  return result.data;
}

export async function listChampionVideoRenderJobs(institutionId) {
  const callable = getFunctions().httpsCallable("listChampionVideoRenderJobs");
  const result = await callable({ institutionId });
  return result.data?.jobs || [];
}

export async function requestChampionVideoRender({ institutionId, videoId }) {
  const callable = getFunctions().httpsCallable("requestChampionVideoRender");
  const result = await callable({ institutionId, videoId });
  return result.data;
}

export async function generateChampionVideoShareLink({ institutionId, videoId }) {
  const callable = getFunctions().httpsCallable("generateChampionVideoShareLink");
  const result = await callable({ institutionId, videoId });
  return result.data;
}

export async function listChampionVideoShareLinks(institutionId) {
  const callable = getFunctions().httpsCallable("listChampionVideoShareLinks");
  const result = await callable({ institutionId });
  return result.data?.links || [];
}

export async function resolveChampionVideoShareLink(linkCode) {
  const callable = getFunctions().httpsCallable("resolveChampionVideoShareLink");
  const result = await callable({ linkCode });
  return result.data;
}

/**
 * Collapse jobs into per-video status for the six sponsor slots.
 * Prefers complete > pending/processing > none.
 */
export function resolveVideoStatuses(jobs = []) {
  const byVideo = {};
  CHAMPION_VIDEO_SLOTS.forEach(({ videoId }) => {
    byVideo[videoId] = { status: "none", job: null };
  });

  jobs.forEach((job) => {
    const ids = [];
    if (job.videoId) ids.push(job.videoId);
    if (Array.isArray(job.requestedVideoIds)) {
      job.requestedVideoIds.forEach((id) => ids.push(id));
    }
    ids.forEach((videoId) => {
      if (!byVideo[videoId]) return;
      const current = byVideo[videoId];
      const rank = { none: 0, pending: 1, processing: 1, complete: 2 };
      const nextRank = rank[job.status] || 0;
      const curRank = rank[current.status] || 0;
      if (nextRank > curRank) {
        byVideo[videoId] = {
          status:
            job.status === "complete"
              ? "complete"
              : job.status === "processing"
                ? "pending"
                : job.status === "pending"
                  ? "pending"
                  : current.status,
          job,
        };
      }
    });
  });

  return byVideo;
}
